module.exports = __webpack_public_path__ + "static/assets/75f9afacabfecf27ba6d5c4d792a4df9.svg";